import { useEffect, useState, VFC } from "react";
import { Col, Input, message, Modal, Row } from "antd";
import { useSelector } from "../../../redux/store";
import { CopyOutlined } from "@ant-design/icons";

export const GameMasterGameStartModal: VFC = () => {
  const [showModal, setShowModal] = useState(false);

  const game = useSelector((state) => state.game.game);
  const currentUser = useSelector((state) => state.auth.user);

  const isGameMaster = game?.masterUserId === currentUser?.uid;
  useEffect(() => {
    const membersCount = Object.keys(game?.membersMap ?? {}).length;
    if (isGameMaster && membersCount < 2) {
      setShowModal(true);
    }
    //eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [isGameMaster]);

  return (
    <Modal
      destroyOnClose
      maskClosable={false}
      cancelButtonProps={{ hidden: true }}
      title={"Lade deine Mitspieler ein"}
      onCancel={() => setShowModal(false)}
      onOk={() => setShowModal(false)}
      visible={showModal}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          Du kannst die anderen Spieler einladen in dem du den Link kopierst und
          an sie schickst.
        </Col>
        <Col span={24}>
          <Input
            readOnly
            value={window.location.href}
            addonAfter={
              <CopyOutlined
                onClick={async () => {
                  await navigator.clipboard.writeText(window.location.href);
                  message.success("URL kopiert.");
                }}
              />
            }
          />
        </Col>
      </Row>
    </Modal>
  );
};
